import React from 'react';
import { useTranslation } from 'react-i18next';

const HelpChat = () => {
  const { t } = useTranslation();

  return <div id='help-chat' className='help-chat animated zoomIn faster' onClick={() => {
    if(window.fcWidget.isOpen() !== true) {
      window.fcWidget.open();
    }
  }}>
    <div className='content'>{t('helpChat.help')}</div>
  </div>;
};

export default HelpChat;
